module.exports = __webpack_public_path__ + "me_logo_small.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/me_logo_small.png
// module id = 307
// module chunks = 0